import {ErrorState, Spinner} from "@rio-cloud/rio-uikit";
import React from "react";

type Props = {
    isLoading: boolean
    error: any
    children: React.ReactNode
}

export const DataLoadingError = ({isLoading, error, children}: Props) => {
    if (isLoading) {
        return <Spinner/>
    }

    if (error !== null && error !== undefined) {
        if (error?.data?.message || error.status) {
            return <ErrorState
                outerClassName='border-none'
                headline='An Error Occured'
                message={error?.data?.message || error?.status}
            />
        }
        return <ErrorState
            outerClassName='border-none'
            headline='An Error Occured'
            message={"Something went wrong"}
        />
    }

    return children
}